import React from "react";
import "./How_We_Work.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const How_We_Work = () => {
  const data = [
    {
      img: "/assets/images/home/how_we_work/site.jpeg",
      title: "Site Visit & Consultation",
      descn: "Understanding your needs, budget, likes & dislikes",
    },
    {
      img: "/assets/images/home/how_we_work/quototion.jpeg",
      title: "Quotation & Planning",
      descn: "Transparent pricing and scope finalization.",
    },
    {
      img: "/assets/images/home/how_we_work/img3.png",
      title: " 3D Design & Approval ",
      descn: " Virtual walkthroughs to finalize the design.",
    },
    {
      img: "/assets/images/home/how_we_work/img4.png",
      title: " Material Selection Assistance ",
      descn: "Guidance for flooring, laminates, paints & finishes",
    },
  ];

  return (
    <section className="How_We_Work">
      <div className="container">
        <Common_Title
          pageTitle="HOW WE WORK "
          boxText="Descriptive "
          subText=" Process for Exceptional Results"
          darkText="Our process is alive – adapting, refining, and growing with your vision. Always!"
          simpleText="We believe in creating personalized interiors that reflect your lifestyle"
        />

        <div className="we_work_cards_holder">
          <div className="row">
            {data?.map((item, index) => {
              return (
                <div className="col-md-6 col-6 mb-3">
                  <div className="we_work_card">
                    <div className="card_img_holder">
                      <img src={item?.img} className="card_img" />
                    </div>
                    <div className="text_holder">
                      <div className="left_side">
                        <p className="title_text">{item?.title}</p>
                        <p className="descn_text">{item?.descn}</p>
                      </div>
                      <p className="no_text">0{index + 1}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default How_We_Work;
